<template>
  <ZigzagServiceLayout
    mainTitle="PRP y Microneedling: Regeneración Natural"
    mainDescription="Nuestras terapias con PRP (Plasma Rico en Plaquetas) utilizan los propios factores de crecimiento de su cuerpo y están diseñadas para apoyar la recuperación y apariencia de la piel."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'PRPMicroneedlingFacialContentEs',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ESTÉTICA',
          title: 'Rejuvenecimiento de la Piel',
          subtitle: 'Estimula el colágeno para una textura más suave y un brillo natural.',
          paragraphs: [
            "Aprovechamos el poder de los factores de crecimiento de su propio cuerpo para transformar su piel.",
            "La terapia PRP puede ayudar a mejorar la textura y el tono de la piel, y está diseñada para apoyar el rejuvenecimiento general de la piel para una apariencia renovada."
          ],
          list: [
            "Estimula la producción de colágeno",
            "Apoya una textura de piel más suave",
            "Puede ayudar a mejorar la textura y el tono de la piel",
            "Mejora el brillo natural"
          ],
          image: '/images/services/prp-skin.png'
        },
        {
          label: 'RESTAURACIÓN',
          title: 'Restauración del Cabello PRP',
          subtitle: 'Fortalece los folículos y promueve el crecimiento.',
          paragraphs: [
            "La terapia PRP ayuda a combatir el adelgazamiento y la pérdida de cabello sin cirugía.",
            "Al dirigirse a los folículos con plaquetas concentradas, este tratamiento reduce la caída y estimula un crecimiento de cabello más robusto."
          ],
          list: [
            "Enfoque de restauración capilar no quirúrgico",
            "Fortalece los folículos pilosos desde la raíz",
            "Reduce la caída de cabello significativamente",
            "Promueve el crecimiento de cabello más grueso"
          ],
          image: '/images/services/prp-hair.png'
        }
      ]
    };
  }
};
</script>
